import React from "react";
import { TextField, TextFieldProps } from "@mui/material";

const NumericTextField: React.FC<TextFieldProps> = (props) => {
  return (
    <TextField
      {...props}
      type="text"
      sx={
        props.sx || {
          "& .MuiInputBase-input": {
            maxHeight: "36px",
            // padding:"12px 13px"
          },
        }
      }
      slotProps={{
        input: {
          inputMode: "decimal",
          onInput: (e: React.ChangeEvent<HTMLInputElement>) => {
            const target = e.target;
            target.value = target.value.replace(/[^0-9.]/g, "");
            const parts = target.value.split(".");
            if (parts.length > 2) {
              target.value = parts[0] + "." + parts[1];
            }
            if (parseFloat(target.value) < 0) {
              target.value = "0";
            }
          },
        },
      }}
    />
  );
};

export default NumericTextField;
